import { render, staticRenderFns } from "./AtomTextArea.vue?vue&type=template&id=be7d338a&"
import script from "./AtomTextArea.vue?vue&type=script&lang=ts&"
export * from "./AtomTextArea.vue?vue&type=script&lang=ts&"
import style0 from "./AtomTextArea.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VTextarea})
